import * as R from 'ramda';
import {
  EDealType,
  ECategoryType,
  EObjectType,
  EOfficeType,
  ERentTime,
  IJsonQuery,
  IJsonQueryType,
  EOfferType,
} from './types';
import { offerTypeFromJsonQuery } from '../category';
import { setRootType, setTerm, setTerms } from './helpers';
import { selectOfferType } from './selectOfferType';

const EDealTypeName = new Map<EDealType, string>([
  [EDealType.Sale, 'sale'],
  [EDealType.RentDaily, 'rent'],
  [EDealType.RentLongterm, 'rent'],
]);

const FCategoryMap = new Map<EDealType, ECategoryType>([
  [EDealType.RentLongterm, ECategoryType.CommercialLandRent],
  [EDealType.Sale, ECategoryType.CommercialLandSale],
]);

export function setDealType(jsonQuery: IJsonQuery) {
  return (nextDealType: EDealType): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    const type = jsonQuery._type;
    const category = jsonQuery.category;

    let nextType: IJsonQueryType = 'flatrent';

    const nextDealTypeString = EDealTypeName.get(nextDealType);
    if (nextDealTypeString) {
      nextType = type.replace(/rent|sale/, nextDealTypeString) as IJsonQueryType;
    }

    nextJsonQuery = setRootType(nextType)(nextJsonQuery);

    /**
     * Переключает на валидный offerType в соответствии с _type
     * Например: Выбрали dealType посуточно,
     * когда фильтры были для комерческой - переключит на посуточную аренду вторички
     */
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const nextOfferType = resetNextOfferType(nextDealType, offerType);
    if (nextOfferType) {
      nextJsonQuery = selectOfferType(nextJsonQuery)(nextOfferType);
    }
    // --------------------------------------------------------------------

    nextJsonQuery = setTerm('category')(nextJsonQuery)(undefined);
    nextJsonQuery = setTerm('for_day')(nextJsonQuery)(undefined);

    if ((nextDealType & EDealType.Rent) !== 0) {
      if (nextDealType === EDealType.RentDaily) {
        nextJsonQuery = setTerm('for_day')(nextJsonQuery)(ERentTime.Daily);
      } else {
        if (category) {
          nextJsonQuery = setTerms('category')(nextJsonQuery)([FCategoryMap.get(nextDealType) as ECategoryType]);
        }
        nextJsonQuery = setTerm('for_day')(nextJsonQuery)(ERentTime.NotDaily);
      }
    }

    if (/rent|sale/.test(nextType) && jsonQuery.office_type?.value.includes(EOfficeType.Coworking)) {
      if (nextJsonQuery.object_type) {
        nextJsonQuery = setTerms('object_type')(nextJsonQuery)([EObjectType.House]);
      }

      if (nextJsonQuery.office_type) {
        nextJsonQuery = setTerms('office_type')(nextJsonQuery)([EOfficeType.Office]);
      }
    }

    return nextJsonQuery;
  };
}

function resetNextOfferType(dealType: EDealType, offerType: EOfferType) {
  switch (dealType) {
    case EDealType.RentLongterm:
      if (offerType & (EOfferType.FlatNew | EOfferType.FlatShared)) {
        return EOfferType.Flat;
      }
      break;
    case EDealType.RentDaily:
      if (offerType & (EOfferType.Any & ~EOfferType.FlatOld & ~EOfferType.Room & ~EOfferType.Bed & ~EOfferType.House)) {
        return EOfferType.Flat;
      }
      break;
    case EDealType.Sale:
      if (offerType & (EOfferType.FlatOld | EOfferType.Bed)) {
        return EOfferType.Flat;
      }
      break;
  }

  return null;
}
